import http from "../http-common";

class PreferencesService {
  getPreferencesList() {
    return http.get("/preferences");
  }
}

export default new PreferencesService();